import { createFileRoute, notFound, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/reports/platform-ledger')({
  component: PlatformLedgerReportLayout,
  loader: ({ context, params }) => {
    if (!context.ability.can('list', 'transactions')) throw notFound()

    if (+params.orgId !== Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID)) {
      throw redirect({
        to: '/$orgId/reports',
        params: { orgId: params.orgId },
      })
    }

    return { isReadOnly: true }
  },
})

function PlatformLedgerReportLayout() {
  return <Outlet />
}
